var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlide2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 206.19 146.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-5, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        opacity: 0;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 37.49,
    y1: 48.66,
    x2: 79.83,
    y2: 48.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 92.44,
    y1: 67.19,
    x2: 173.1,
    y2: 67.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 49.8,
    y1: 103.02,
    x2: 110.11,
    y2: 103.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "blue"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 71.71,
    y1: 139.14,
    x2: 125.22,
    y2: 139.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19.41.65h7.01l8.11,17.98L42.58.65h6.95v23.17h-4.58l.19-19.15h-.06l-8.57,19.15h-4.15L23.86,4.67h-.06l.19,19.15h-4.58V.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.89,16.35c.1,1.92,1.4,4.87,5.84,4.87,2.95,0,4.25-1.04,5.13-2.47h4.87c-.97,1.92-3.31,5.71-9.87,5.71-7.76,0-10.65-4.51-10.65-9.09,0-5.74,4.25-9.41,10.35-9.41,7.63,0,10.55,4.71,10.55,9.74v.65h-16.23ZM69.45,13.5c-.55-3.44-3.6-4.48-5.81-4.48-2.08,0-5,.97-5.74,4.48h11.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.26,16.35c.1,1.92,1.4,4.87,5.84,4.87,2.95,0,4.25-1.04,5.13-2.47h4.87c-.97,1.92-3.31,5.71-9.87,5.71-7.76,0-10.65-4.51-10.65-9.09,0-5.74,4.25-9.41,10.35-9.41,7.63,0,10.55,4.71,10.55,9.74v.65h-16.23ZM92.81,13.5c-.55-3.44-3.6-4.48-5.81-4.48-2.08,0-5,.97-5.74,4.48h11.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M102.04,9.86h-3.57v-3.25h3.57V1.3h4.48v5.32h4.67v3.25h-4.67v7.85c0,1.98.1,3.05,1.62,3.05,1.1,0,2.14-.03,3.21-.06v3.25c-1.2.16-2.08.26-3.44.26-5.45,0-5.88-1.95-5.88-5.19v-9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.31.65h4.87v16.16c0,3.25-1.4,7.66-8.63,7.66-8.86,0-8.96-5.58-8.96-8.99h4.87c0,2.4.03,5.35,4.02,5.35s3.83-3.05,3.83-5.39V.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156.24,5.97c7.69,0,10.64,4.51,10.64,9.25s-2.95,9.25-10.64,9.25-10.65-4.51-10.65-9.25,2.95-9.25,10.65-9.25ZM156.24,21.03c4.35,0,5.97-2.82,5.97-5.81s-1.62-5.81-5.97-5.81-5.97,2.82-5.97,5.81,1.62,5.81,5.97,5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.38,20.57l11.59-10.52h-10.97v-3.44h17.36v3.05l-11.81,10.71h12.24v3.44h-18.4v-3.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.49,41.8h11.28v2.13h-8.43v3.42h7.98v2.13h-7.98v5.89h-2.85v-13.56ZM50.28,41.57h2.62v13.79h-2.62v-13.79ZM57.62,50.99c.06,1.12.82,2.85,3.42,2.85,1.73,0,2.49-.61,3-1.44h2.85c-.57,1.12-1.94,3.34-5.78,3.34-4.54,0-6.23-2.64-6.23-5.32,0-3.36,2.49-5.51,6.06-5.51,4.46,0,6.17,2.75,6.17,5.7v.38h-9.5ZM64.38,49.32c-.32-2.01-2.11-2.62-3.4-2.62-1.22,0-2.93.57-3.36,2.62h6.76ZM71.74,50.18l-4.2-4.88h3.38l2.58,3.27,2.64-3.27h3.38l-4.24,4.88,4.54,5.19h-3.5l-2.83-3.57-2.91,3.57h-3.38l4.52-5.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.48,60.33h3.38l6.04,13.56h-3.17l-1.42-3.36h-6.38l-1.41,3.36h-3.08l6.04-13.56ZM102.45,68.41l-2.32-5.72-2.36,5.72h4.67ZM111.26,70.75c.08,1.52,1.82,1.75,2.77,1.75,1.31,0,2.74-.34,2.74-1.29,0-.78-.44-1.04-3.27-1.42-3.12-.42-4.75-.78-4.75-3.08,0-2.87,3.34-3.25,5.03-3.25,1.56,0,5.3.23,5.45,3.46h-2.74c-.21-1.5-1.96-1.67-2.85-1.67-1.48,0-2.28.63-2.28,1.16,0,.82.25.95,2.77,1.31,3.31.47,5.47.8,5.47,3.13,0,2.56-2.45,3.44-5.57,3.44-2.15,0-5.55-.46-5.64-3.53h2.85ZM129.94,67.36c-.19-1.04-1.29-1.9-2.79-1.9-2.43,0-3.5,1.65-3.5,3.4s.95,3.4,3.21,3.4c2.03,0,2.58-.8,3.13-2.22h2.74c-.61,4.18-4.88,4.24-5.58,4.24-4.5,0-6.23-2.64-6.23-5.41,0-3.25,2.34-5.41,6.23-5.41,1.52,0,4.98.51,5.53,3.91h-2.74ZM136.89,69.53c.06,1.12.82,2.85,3.42,2.85,1.73,0,2.49-.61,3-1.44h2.85c-.57,1.12-1.94,3.34-5.78,3.34-4.54,0-6.23-2.64-6.23-5.32,0-3.36,2.49-5.51,6.06-5.51,4.46,0,6.17,2.75,6.17,5.7v.38h-9.5ZM143.65,67.86c-.32-2.01-2.11-2.62-3.4-2.62-1.22,0-2.93.57-3.36,2.62h6.76ZM148.3,63.83h2.62v1.52h.04c.85-1.08,2.18-1.79,3.97-1.79,2.17,0,4.27.78,4.27,3.5v6.84h-2.62v-6c0-1.08-.36-2.32-2.53-2.32-1.37,0-3.13.76-3.13,2.91v5.41h-2.62v-10.07ZM173.1,73.9h-2.62v-1.39h-.04c-.19.61-1.77,1.77-3.86,1.77-3.84,0-5.51-2.79-5.51-5.38s1.67-5.34,5.51-5.34c1.58,0,3.08.49,3.86,1.71h.04v-5.17h2.62v13.79ZM167.21,72.26c2.45,0,3.38-1.65,3.38-3.36s-.93-3.32-3.38-3.32-3.4,1.65-3.4,3.32.93,3.36,3.4,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.8,94.15h4.1l4.75,10.52,4.71-10.52h4.07v13.56h-2.68l.11-11.21h-.04l-5.01,11.21h-2.43l-4.98-11.21h-.04l.11,11.21h-2.68v-13.56ZM75.84,97.27c4.5,0,6.23,2.64,6.23,5.41s-1.73,5.41-6.23,5.41-6.23-2.64-6.23-5.41,1.73-5.41,6.23-5.41ZM75.84,106.08c2.54,0,3.5-1.65,3.5-3.4s-.95-3.4-3.5-3.4-3.5,1.65-3.5,3.4.95,3.4,3.5,3.4ZM95.83,97.61v9.76c0,2.39-1.54,4.52-5.98,4.52-3.12,0-5.68-.68-5.91-3.29h2.74c.27,1.29,1.5,1.5,3.1,1.5,3,0,3.44-1.6,3.44-2.91v-1.22h-.06c-1.25,1.2-2.56,1.62-4.1,1.62-2.66,0-5.6-1.35-5.6-5.09,0-2.58,1.71-5.13,5.58-5.13,2.03,0,3.53.65,4.14,1.71h.04v-1.48h2.62ZM89.83,105.59c2,0,3.38-1.29,3.38-3.15,0-2.41-2.26-3.04-3.61-3.04-1.96,0-3.42,1.27-3.42,3.08,0,1.48.89,3.12,3.65,3.12ZM110.11,97.61v9.76c0,2.39-1.54,4.52-5.98,4.52-3.12,0-5.68-.68-5.91-3.29h2.74c.27,1.29,1.5,1.5,3.1,1.5,3,0,3.44-1.6,3.44-2.91v-1.22h-.06c-1.25,1.2-2.56,1.62-4.1,1.62-2.66,0-5.6-1.35-5.6-5.09,0-2.58,1.71-5.13,5.58-5.13,2.03,0,3.53.65,4.14,1.71h.04v-1.48h2.62ZM104.11,105.59c2,0,3.38-1.29,3.38-3.15,0-2.41-2.26-3.04-3.61-3.04-1.96,0-3.42,1.27-3.42,3.08,0,1.48.89,3.12,3.65,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.02,131.97c2.09,0,6.27.38,6.63,4.31h-3.08c-.09-1.04-1.04-2.19-3.42-2.19-1.9,0-3.15.59-3.15,1.86,0,3.19,10.11.13,10.11,5.93,0,3.5-3.63,4.41-6.52,4.41-4.88,0-6.84-1.92-6.88-4.77h3.08c.08,1.79,1.56,2.64,3.89,2.64,1.73,0,3.34-.51,3.34-2,0-3.36-9.99-.44-9.99-6,0-3.02,2.68-4.2,5.98-4.2ZM86.93,132.13h2.62v7.75l4.65-4.03h3.7l-4.65,3.8,5.05,6.27h-3.53l-3.57-4.6-1.65,1.35v3.25h-2.62v-13.79ZM99.42,132.13h2.62v2.13h-2.62v-2.13ZM99.42,135.85h2.62v10.07h-2.62v-10.07ZM104.48,132.13h2.62v13.79h-2.62v-13.79ZM109.53,132.13h2.62v13.79h-2.62v-13.79ZM116.86,142.76c.08,1.52,1.82,1.75,2.77,1.75,1.31,0,2.74-.34,2.74-1.29,0-.78-.44-1.04-3.27-1.42-3.12-.42-4.75-.78-4.75-3.08,0-2.87,3.34-3.25,5.03-3.25,1.56,0,5.3.23,5.45,3.46h-2.74c-.21-1.5-1.96-1.67-2.85-1.67-1.48,0-2.28.63-2.28,1.16,0,.82.25.95,2.77,1.31,3.31.47,5.47.8,5.47,3.13,0,2.56-2.45,3.44-5.57,3.44-2.15,0-5.55-.46-5.64-3.53h2.85Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 206.19,
    height: 146.94
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2);
export default __webpack_public_path__ + "static/media/slide2.c3ea5fc3073f5ff38fde2a69377091d9.svg";
export { ForwardRef as ReactComponent };